import { put } from "@redux-saga/core/effects";

import { FieldsService } from "../../../services/fields";
import { AddMarkerRequestActionType, markersResponse } from "../types";
import { addMarkerFailure, addMarkerSuccess } from "../actionCreaters";

export function* addMarkerSaga({ payload: { fieldId, markerData, markerId } }: AddMarkerRequestActionType) {
    try {
        const {
            data: { data },
        }: markersResponse = yield FieldsService.addMarker(fieldId, markerData);

        yield put(addMarkerSuccess({ fieldId, markers: data.markers }));
    } catch (error) {
        yield put(addMarkerFailure({ fieldId }));
        // yield put(Handle Error);
    }
}
